import React, { useState, useEffect } from "react";
import { Drawer, IconButton, List, Typography, useMediaQuery } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

import { NotificationsNone as NotificationsIcon, LibraryBooks as LibraryIcon, ArrowBack as ArrowBackIcon, SupervisedUserCircle } from "@material-ui/icons";

import { useTheme } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import classNames from "classnames";
import SchooleRegistrationService from "../../pages/dashboard/Locality/Service/schooleRegistration";
import TeacherService from "../../pages/dashboard/Locality/Service/teacherService";
import { isViewingChildSchool } from "../../utils/schoolImpersonation";
import { isPathAllowed } from "../../rbac/rbacAccess";
// styles
import useStyles from "./styles";
// components
import SidebarLink from "./components/SidebarLink/SidebarLink";

// context
import { useLayoutState, useLayoutDispatch, toggleSidebar } from "../../context/LayoutContext";
const CustomIcon = ({ src, alt, size = 24 }) => (
  <img 
    src={src} 
    alt={alt} 
    style={{ 
      width: size, 
      height: size,
      objectFit: 'contain'
    }} 
  />
);

const userManualMenuItem = {
  id: 27,
  label: "User Manual",
  link: "/app/usermanual",
  icon: <LibraryIcon />,
};

let structure = [
  // { id: 0, label: "Student Registration", link: "/app/studentregistration", icon: <TypographyIcon /> },
  // {
  //   id: 8,
  //   label: "Calendar of events",
  //   link: "/app/calenderevents",
  //   icon: <CalendarToday />,
  // },
  {
    id: 3,
    label: "Student Details",
    link: "/app/studentdetails",
    icon: <CustomIcon src="/images/Student Details.png" alt="Student Details" />,
  },
  { id: 1, label: " Class", link: "/app/addclass", icon: <CustomIcon src="/images/Language materials reports.png" alt="Class" /> },
  {
    id: 2,
    label: "Teacher",
    link: "/app/teacher",
    icon: <CustomIcon src="/images/teacher.png" alt="Teacher" />,
  },
 
 
  // {
  //   id: 3,
  //   label: "School Details",
  //   link: "/app/schooldetails",
  //   icon: <HotTub />,
  // },
  {
    id: 4,
    label: "Attendance",
    link: "/app/attendence",
    icon: <CustomIcon src="/images/Attendance.png" alt="Attendance" />,
  },
  
  {
    id: 7,
    label: "Activity Planner",
    link: "/app/studentactivity",
    icon: <CustomIcon src="/images/Activity planner.png" alt="Activity Planner" />,
  },
  // {
  //   id: 8,
  //   label: "Weekly planner",
  //   link: "/app/activityexpected",
  //   icon: <HistorySharp />,
  // },
  {
    id: 18, 
    label: "Calendar Of Events",
    link: "/app/calenderassignment",
    icon: <CustomIcon src="/images/Calendar of events.png" alt="Calendar of Events" />,
  },
  // {
  //   id: 9,
  //   label: "Create Events",
  //   link: "/app/createevents",
  //   icon: <Create />,
  // },
  { label: "Special Observation", link: "/app/specialobservation",
  icon: <CustomIcon src="/images/Special observation.png" alt="Special Observation" />},
  
  //   {
  //   id: 10,
  //   label: "Sounds",
  //   link: "/app/sound",
  //   icon: <TableIcon />,
  // },
  {
    id: 11,
    label: "Reports",
    icon: <CustomIcon src="/images/Reports.png" alt="Reports" />,
    children: [
       { label: "Attendance Reports", link: "/app/reports" },
      //  { label: "Activity Reports", link: "/app/reportofactivities" },
      { label: "Class Reports", link: "/app/agereports" },
      { label: "Teacher report ratings", link: "/app/teacher-report-ratings" },
     
    ],
  },
  // { id: 5, type: "divider" },
  // { id: 6, type: "title", label: "HELP" },
  // { id: 7, label: "Library", link: "https://flatlogic.com/templates", icon: <LibraryIcon /> },
  // { id: 8, label: "Support", link: "https://flatlogic.com/forum", icon: <SupportIcon /> },
  // { id: 9, label: "FAQ", link: "https://flatlogic.com/forum", icon: <FAQIcon /> },
  // { id: 10, type: "divider" },
  // { id: 11, type: "title", label: "PROJECTS" },
  // {
  //   id: 12,
  //   label: "My recent",
  //   link: "",
  //   icon: <Dot size="small" color="warning" />,
  // },
  // {
  //   id: 13,
  //   label: "Starred",
  //   link: "",
  //   icon: <Dot size="small" color="primary" />,
  // },
  // {
  //   id: 14,
  //   label: "Background",
  //   link: "",
  //   icon: <Dot size="small" color="secondary" />,
  // },
];
const teacher=[
    {
    id: 4,
    label: "Activity Planner ",
    link: "/app/studentactivity",
    icon: <CustomIcon src="/images/Activity planner.png" alt="Activity Planner" />,
  },
  // {
  //   id: 5,
  //   label: "Weekly planner",
  //   link: "/app/activityexpected",
  //   icon: <HistorySharp />,
  // },
  {
    id: 3,
    label: "Attendance",
    link: "/app/attendence",
    icon: <CustomIcon src="/images/Attendance.png" alt="Attendance" />,
  },
   {
    id: 18,
    label: "Assignment",
    link: "/app/event",
    icon: <CustomIcon src="/images/Activity planner.png" alt="Assignment" />,
  },
  {
    id: 8,
    label: "Lesson plan ",
    link: "/app/teacherlesson",
    icon: <CustomIcon src="/images/Language materials reports.png" alt="Lesson plan" />,
  },
  // {
  //   id: 2,
  //   label: "Student Details",
  //   link: "/app/studentdetails",
  //   icon: <HotTub />,
  // },
   {
    id: 11,
    label: "Language ",
    icon: <CustomIcon src="/images/Language materials reports.png" alt="Language Materials" />,
    children: [
       { label: "Phonics", link: "/app/sound" },
      { label: "Movable Alphabets", link: "/app/movablealphabets" },
      { label: "Cursive Alphabets", link: "/app/cursive" },
    
     
    ],
  },

  
  
  // {
  //   id: 1,
  //   label: "Activity Status",
  //   link: "/app/activityreport",
  //   icon: <CustomIcon src="/images/Calendar of events.png" alt="Calendar" />,
  // },

  
 
  // {
  //   id: 7,
  //   label: "Activity List",
  //   link: "/app/activitytabel",
  //   icon: <AccessAlarmSharp />,
  // },
 {
    id: 18,
    label: "Calendar Of Events",
    link: "/app/calenderassignment",
    icon: <CustomIcon src="/images/Calendar of events.png" alt="Calendar of Events" />,
  },
  {
    id: 31,
    label: "Event Reminders",
    link: "/app/teacher-notifications",
    icon: <NotificationsIcon />,
  },
  {
    id: 19,
    label: "Captured Moments",
    link: "/app/imagesstore",
    icon: <CustomIcon src="/images/Calendar of events.png" alt="Images Store" />,
  },
  {
    id: 3,
    label: "Notes for report",
    link: "/app/teachernotes",
    icon: <CustomIcon src="/images/Notes for report.png" alt="Notes" />,
  },

  // {
  //   id: 19,
  //   label: "Messages from Parents",
  //   link: "/app/notelist",
  //   icon: <CustomIcon src="/images/Language materials reports.png" alt="Messages from Parents" />,
  // },

  {
    id: 6,
    label: "Reports",
    icon: <CustomIcon src="/images/Reports.png" alt="Reports" />,
    children: [
      { label: "Attendance Reports", link: "/app/reports" },
      { label: "Activity Reports", link: "/app/reportofactivities" },
      { label: "Student assessments", link: "/app/teacher-report-ratings" },
      {
      
        label: "Activity Performance Progress",
        link: "/app/activitytrackertable",
    
      },
      {
        
        label: "Activity Analysis",
        link: "/app/activityanalysis",
       
      },
    ],
  },
 
 
    {
    id: 18,
    label: "Training Session",
    link: "/app/trainingsession",
    icon: <CustomIcon src="/images/Language materials reports.png" alt="Training Session" />,
  },
  userManualMenuItem,
 
  
]; 
const superAdmin=[
  {
    id: 0,
    label: "School Details",
    link: "/app/schooldetails",
    icon: <CustomIcon src="/images/Language materials reports.png" alt="School Details" />,
  },
  {
    id: 999,
    label: "Student Charge Master",
    link: "/app/student-charge-master",
    icon: <CustomIcon src="/images/Fee.png" alt="Student Charge Master" />,
  },
  {
    id: 998,
    label: "Users & Roles",
    link: "/app/users-and-roles",
    icon: <SupervisedUserCircle />,
  },
  {
    id: 997,
    label: "App Version",
    link: "/app/app-version",
    icon: <CustomIcon src="/images/Language materials reports.png" alt="App Version" />,
  },
  { id: 1, label: " Class", link: "/app/addclass", icon: <CustomIcon src="/images/Language materials reports.png" alt="Class" /> },

  { id: 1, label: "Subject", link: "/app/subject", icon: <CustomIcon src="/images/Language materials reports.png" alt="Subject" /> },
  // {
  //   id: 2,
  //   label: "Lesson",
  //   link: "/app/lesson",
  //   icon: <CustomIcon src="/images/Reports.png" alt="Reports" />,
  // },
  {
    id: 6,
    label: "Activity Catalogue",
    link: "/app/activity-catalog",
    icon: <CustomIcon src="/images/Language materials reports.png" alt="Activity Catalog" />,
  },
  {
    id: 11,
    label: "Language ",
    icon: <CustomIcon src="/images/Language materials reports.png" alt="Language Materials" />,
    children: [
      { label: "Phonics Master", link: "/app/soundmaster" },
      { label: "Movable Master", link: "/app/movablemaster" },
      { label: "Cursive Master", link: "/app/cursivemaster" },
    ],
  },
   {
    id: 6,
    label: "Trainer Registration ",
    link: "/app/registrationtrainer",
    icon: <CustomIcon src="/images/Language materials reports.png" alt="Trainer Registration" />,
  },
   {
    id: 6,
    label: "Training Topics ",
    link: "/app/trainer",
    icon: <CustomIcon src="/images/Language materials reports.png" alt="School Details" />,
  },
   {
    id: 7,
    label: "Academic Master" ,
    link: "/app/academicyear",
    icon: <CustomIcon src="/images/Fee.png" alt="Academic Year" />,
  },
  {
    id: 23,
    label: "Food Menu Master",
    link: "/app/foodmaster",
    icon: <CustomIcon src="/images/Reports.png" alt="Food Menu Master" />,
  },
 
  // {
  //   id: 8,
  //   label: "Schedule",
  //   link: "/app/schedule",
  //   icon: <CustomIcon src="/images/Language materials reports.png" alt="Schedule" />,
  // },
  {
    id: 11,
    label: "Icon Master",
    link: "/app/iconmaster",
    icon: <CustomIcon src="/images/Language materials reports.png" alt="Icon Master" />,
  },
  // {
  //   id: 12,
  //   label: "Images Store",
  //   link: "/app/imagesstore",
  //   icon: <CustomIcon src="/images/Calendar of events.png" alt="Images Store" />,
  // },
  // {
  //   id: 20,
  //   label: "Enquiry Form",
  //   link: "/app/enquiry",
  //   icon: <CustomIcon src="/images/Reports.png" alt="Enquiry Form" />,
  // },
];
const parent=[
 
 
  {
    id: 2,
    label: "Assignment",
    link: "/app/assignment",
    icon: <CustomIcon src="/images/Language materials reports.png" alt="School Details" />,
  },
  {
    id: 30,
    label: "Notifications",
    link: "/app/parent-notifications",
    icon: <NotificationsIcon />,
  },
  {
    id: 1,
    label: "Calendar",
    link: "/app/studentEvents",
    icon: <CustomIcon src="/images/Calendar of events.png" alt="Calendar" />,
  },
  //  {
  //   id: 1,
  //   label: "Activity For Student",
  //   link: "/app/parentactivity",
  //   icon: <CustomIcon src="/images/Activity planner.png" alt="Activity Planner" />,
  // },
   {
    id: 2,
    label: "Activity Progress",
    link: "/app/parentactivitytrackertable",
    icon: <CustomIcon src="/images/Activity planner.png" alt="Activity Planner" />,
  },
   {
    id: 2,
    label: "Student Story",
    link: "/app/studentstory",
    icon: <CustomIcon src="/images/Activity performance progress.png" alt="Student Story" />,
  },
  // {
  //   id: 31,
  //   label: "MileStones & Memories",
  //   link: "/app/milestones-memories",
  //   icon: <CustomIcon src="/images/Reports.png" alt="MileStones and Memories" />,
  // },
 
  {
    id: 4,
    label: "Fee Payments",
    link: "/app/parentfee",
    icon: <CustomIcon src="/images/Fee.png" alt="Fee Payments" />,
  },

  {
    id: 6,
    label: "Food Menu",
    link: "/app/parentfoodmenu",
    icon: <CustomIcon src="/images/Reports.png" alt="Food Menu" />,
  },
  {
    id: 26,
    label: "Hand Book",
    link: "/app/parenthandbook",
    icon: <CustomIcon src="/images/Reports.png" alt="Hand Book" />,
  },
  {
    id: 5,
    label: "Write A Message",
    link: "/app/note",
    icon: <CustomIcon src="/images/Language materials reports.png" alt="Note" />,
  },
  {
    id: 3,
    label: "Helpful Information",
    link: "/app/helpfullinformation",
    icon: <CustomIcon src="/images/Reports.png" alt="Helpful Information" />,
  },


];
let schoole = [
  // { id: 0, label: "Student Registration", link: "/app/studentregistration", icon: <TypographyIcon /> },
  // {
  //   id: 8,
  //   label: "Calendar of events",
  //   link: "/app/calenderevents",
  //   icon: <CalendarToday />,
  // },
  {
    id: 21,
    label: "Dashboard",
    link: "/app/addbranchschool",
    icon: <CustomIcon src="/images/Language materials reports.png" alt="Add Branch School" />,
  },
  {
    id: 3,
    label: "Student Details",
    link: "/app/studentdetails",
    icon: <CustomIcon src="/images/Student Details.png" alt="Student Details" />,
  },

  // { id: 1, label: " Class", link: "/app/addclass", icon: <TableIcon /> },
  {
    id: 2,
    label: "Teacher",
    link: "/app/teacher",
    icon: <CustomIcon src="/images/teacher.png" alt="Teacher" />,
  },
  {
    id: 13,
    label: "Section",
    link: "/app/section",
    icon: <CustomIcon src="/images/Language materials reports.png" alt="Section" />,
  },
  {
    id: 12,
    label: "Activity Catalog",
    link: "/app/activity-catalog",
    icon: <CustomIcon src="/images/Language materials reports.png" alt="Activity Catalog" />,
  },
  { id: 13,   label: "Today's Teacher Report", link: "/app/today-teacher-report", icon: <CustomIcon src="/images/Language materials reports.png" alt="Today's Teacher Report" /> },
 {
   id: 2,
  label: "Add Lesson",
  link: "/app/lesson",
  icon: <CustomIcon src="/images/Reports.png" alt="Reports" />,
 },
  // {
  //   id: 7,
  //   label: "Activity Performance Progress",
  //   link: "/app/activitytrackertable",
  //   icon: <CustomIcon src="/images/Activity performance progress.png" alt="Activity Performance Progress" />,
  // },
 
  
  {
    id: 4,
    label: "Attendance",
    link: "/app/attendence",
    icon: <CustomIcon src="/images/Attendance.png" alt="Attendance" />,
  },
  // {
  //   id: 7,
  //   label: "Activity Planner",
  //   link: "/app/studentactivity",
  //   icon: <CustomIcon src="/images/Activity planner.png" alt="Activity Planner" />,
  // },
 
  // {
  //   id: 8,
  //   label: "Weekly planner",
  //   link: "/app/activityexpected",
  //   icon: <HistorySharp />,
  // },
  {
    id: 18, 
    label: "Calendar Of Events",
    link: "/app/calenderassignment",
    icon: <CustomIcon src="/images/Calendar of events.png" alt="Calendar of Events" />,
  },
  // {
  //   id: 19,
  //   label: "Images Store",
  //   link: "/app/imagesstore",
  //   icon: <CustomIcon src="/images/Calendar of events.png" alt="Images Store" />,
  // },
  // {
  //   id: 9,
  //   label: "Create Events",
  //   link: "/app/createevents",
  //   icon: <Create />,
  // },
  // { label: "Special Observation", link: "/app/specialobservation",
  // icon: <CustomIcon src="/images/Special observation.png" alt="Special Observation" />},
  
  //   {
  //   id: 10,
  //   label: "Sounds",
  //   link: "/app/sound",
  //   icon: <TableIcon />,
  // },
  {
    id: 11,
    label: "Reports",
    icon: <CustomIcon src="/images/Reports.png" alt="Reports" />,
    children: [
       { label: "Attendance Reports", link: "/app/reports" },
      //  { label: "Activity Reports", link: "/app/reportofactivities" },
      { label: "Class Reports", link: "/app/agereports" },
      { label: " Attendence Reports", link: "/app/dayreport" },
      { label: "Teacher report ratings", link: "/app/teacher-report-ratings" },
      {  label: "Activity Report",link: "/app/activityreport" },
      {label: "Activity Performance Progress",link: "/app/activitytrackertable",},
    ],
  },
  {
    id: 30,
    label: " Notification",
    link: "/app/push-notifications",
    icon: <NotificationsIcon />,
  },
  // { id: 5, type: "divider" },
  // { id: 6, type: "title", label: "HELP" },
  // { id: 7, label: "Library", link: "https://flatlogic.com/templates", icon: <LibraryIcon /> },
  // { id: 8, label: "Support", link: "https://flatlogic.com/forum", icon: <SupportIcon /> },
  // { id: 9, label: "FAQ", link: "https://flatlogic.com/forum", icon: <FAQIcon /> },
  // { id: 10, type: "divider" },
  // { id: 11, type: "title", label: "PROJECTS" },
  // {
  //   id: 12,
  //   label: "My recent",
  //   link: "",
  //   icon: <Dot size="small" color="warning" />,
  // },
  // {
  //   id: 13,
  //   label: "Starred",
  //   link: "",
  //   icon: <Dot size="small" color="primary" />,
  // },
  // {
  //   id: 14,
  //   label: "Background",
  //   link: "",
  //   icon: <Dot size="small" color="secondary" />,
  // },
  // {
  //   id: 3,
  //   label: "Activity Analysis",
  //   link: "/app/activityanalysis",
  //   icon: <CustomIcon src="/images/Activity analysis.png" alt="Activity Analysis" />,
  // },
  //  {
  //   id: 3,
  //   label: "Activity Wise Analysis ",
  //   link: "/app/keywiseactivity",
  //   icon: <CustomIcon src="/images/Activity wise analysis.png" alt="Activity Wise Analysis" />,
  // },
  {
    id: 3,
    label: "Notes For Report",
    link: "/app/teachernotes",
    icon: <CustomIcon src="/images/Notes for report.png" alt="Notes For Report" />,
  },
  {
    id: 4,
    label: "Fee",
    link: "/app/fee",
    icon: <CustomIcon src="/images/Fee.png" alt="Fee" />,
  },
  // {
  //   id: 41,
  //   label: "Upgrade Plan",
  //   link: "/app/upgrade-plan",
  //   icon: <Payment />,
  // },
  {
    id: 22,
    label: "Enquiry Form",
    link: "/app/enquiry",
    icon: <CustomIcon src="/images/Reports.png" alt="Enquiry Form" />,
  },
  {
    id:23,
    label: "Food",
    icon: <CustomIcon src="/images/Reports.png" alt="Food" />,
    children: [
      { label: "Food Menu ", link: "/app/foodmenu"},
      { label: "Meal schedule",link: "/app/foodmaster"}
    ]
 
  },
  // {
  //   id: 24,
    
  //   icon: <CustomIcon src="/images/Reports.png" alt="Food Menu Planner" />,
  // },
  // {
  //   id: 25,
  //   label: "Meal schedule",
  //   link: "/app/foodmaster",
  //   icon: <CustomIcon src="/images/Reports.png" alt="Food Menu Master" />,
  // },
  {
    id: 26,
    label: "Hand Book",
    link: "/app/handbook",
    icon: <CustomIcon src="/images/Reports.png" alt="Hand Book" />,
  },
  {
    id: 5,
    label: "Messages ",
    link: "/app/notelist",
    icon: <CustomIcon src="/images/Language materials reports.png" alt="Messages " />,
  },
  {
    id: 8,
    label: "Activity Schedule for parent ",
    link: "/app/schedule",
    icon: <CustomIcon src="/images/Language materials reports.png" alt="Schedule" />,
  },
  {
    id: 3.1,
    label: "Promotion",
    link: "/app/promotion",
    icon: <CustomIcon src="/images/Student Details.png" alt="Promotion" />,
  },
  userManualMenuItem,
];

// Language menu is only for primary class teachers (Primary environment).
const isLanguageMenuItem = (item) =>
  String(item?.label || "").trim().toLowerCase() === "language";

const withoutLanguageMenu = (items) =>
  (items || []).filter((item) => !isLanguageMenuItem(item));

const canPrimaryTeacherSeeLanguage = async (userDetails) => {
  const teacherId = userDetails?.teacherId;
  if (!teacherId) return false;

  try {
    const teacher = await TeacherService.getTeacherById(teacherId);
    if (!teacher) return false;

    const primaryClassId = teacher?.classId?._id || teacher?.classId;
    if (!primaryClassId) return false;

    const className = String(teacher?.classId?.className || "").trim().toLowerCase();
    return className === "primary";
  } catch {
    return false;
  }
};

// Hide/show menu items based on the RBAC `screens` the user received at login.
// - Items without a link (dividers/titles) are kept.
// - Items whose link is a role-gated screen are kept only if the user is allowed.
// - Items whose link is not a guarded screen (utility routes) are always kept.
// - Submenu groups are kept only if at least one child remains.
// When RBAC is disabled (no `rbac_screens` in session) isPathAllowed() returns
// true for everything, so the full role menu is shown exactly as before.
function filterMenuByAccess(items) {
  if (!Array.isArray(items)) return [];
  return items
    .map((item) => {
      if (Array.isArray(item.children) && item.children.length) {
        const children = item.children.filter(
          (child) => !child.link || isPathAllowed(child.link)
        );
        if (!children.length) return null;
        return { ...item, children };
      }
      if (item.link && !isPathAllowed(item.link)) return null;
      return item;
    })
    .filter(Boolean);
}

function Sidebar({ location }) {
  var classes = useStyles();
  var theme = useTheme();

  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();

  // local
  var [isPermanent, setPermanent] = useState(true);
  var [sidemenuDetails, setSideMenu] = useState([]);
  const [menuLoading, setMenuLoading] = useState(true);
  const [parentUnreadCount, setParentUnreadCount] = useState(0);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  useEffect(() => {
    const readCount = () => {
      const raw = localStorage.getItem("parent_notifications_unread") || "0";
      const n = Number(raw);
      setParentUnreadCount(Number.isFinite(n) ? n : 0);
    };
    readCount();
    const onCustom = () => readCount();
    window.addEventListener("parent-notifications-unread-changed", onCustom);
    window.addEventListener("storage", onCustom);
    return () => {
      window.removeEventListener("parent-notifications-unread-changed", onCustom);
      window.removeEventListener("storage", onCustom);
    };
  }, []);
  useEffect(function() {
    const userDetails = localStorage.getItem("userDetail") ? JSON.parse(localStorage.getItem("userDetail")) :{};
// if (userDetails.role === "PARENT") {
//   const today = new Date();
//   const day = today.getDay();
//   const hour = today.getHours();
//   const minutes = today.getMinutes();

//   const isAfterFriday3pm = day === 5 && (hour > 15 || (hour === 15 && minutes >= 0));
//   const isWeekend = day === 6 || day === 0;

//   const parentFiltered = parent.filter(
//     item => item.label !== "Activity Progress" || isWeekend || isAfterFriday3pm
//   );

//   structure = parentFiltered;
// }
    // Language menu: primary teachers only (TEACHER role + Primary class assignment)
    const setupMenu = async () => {
      try {
        let menu = structure;

        if (userDetails && userDetails.role === 'TEACHER') {
          menu = teacher;
          const showLanguage = await canPrimaryTeacherSeeLanguage(userDetails);
          if (!showLanguage) {
            menu = withoutLanguageMenu(menu);
          }
        } else if (userDetails && userDetails.role === 'SCHOOLE') {
          menu = schoole;

          if (isViewingChildSchool()) {
            menu = schoole.filter(item => item.label !== 'Add Branch School');
          } else {
            const schoolId = userDetails.schooleId || userDetails.schoolId || userDetails._id;
            if (schoolId) {
              try {
                const school = await SchooleRegistrationService.getSchoolById(schoolId);
                if (!school || school.branch !== 'multiple' || school.parentSchoolId) {
                  menu = schoole.filter(item => item.label !== 'Add Branch School');
                }
              } catch (e) {
                // On error, fall back to showing full schoole menu
              }
            }
          }
        } else if (userDetails && userDetails.role === 'SUPERADMIN') {
          menu = superAdmin;
        } else if (userDetails.role === 'PARENT') {
          menu = parent.map((item) => {
            if (item.link === "/app/parent-notifications") {
              return { ...item, badgeContent: parentUnreadCount > 0 ? parentUnreadCount : undefined };
            }
            return item;
          });
        }

        window.addEventListener("resize", handleWindowWidthChange);
        handleWindowWidthChange();
        setSideMenu(filterMenuByAccess(menu));
      } finally {
        setMenuLoading(false);
      }
    };

    setupMenu();

    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  }, [parentUnreadCount]);

  return (
    <Drawer
    variant={isMobile ? "temporary" : "permanent"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
      onClose={() => toggleSidebar(layoutDispatch)} // Close drawer on mobile
      ModalProps={{
        keepMounted: true, // Keeps performance optimal for mobile
      }}
    >
      <div className={classes.toolbar} />
      {isMobile && (
        <div className={classes.mobileBackButton}>
          <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
            <ArrowBackIcon />
          </IconButton>
        </div>
      )}
      
      <List className={classes.sidebarList}>
        {isSidebarOpened && (
          <Typography className={classes.sectionLabel}>Main</Typography>
        )}
        {menuLoading
          ? Array.from({ length: 10 }).map((_, index) => (
              <div key={`skeleton-${index}`} className={classes.skeletonRow}>
                <Skeleton variant="circle" width={24} height={24} animation="wave" />
                {isSidebarOpened && (
                  <Skeleton
                    variant="text"
                    height={16}
                    animation="wave"
                    className={classes.skeletonText}
                    style={{ width: `${55 + ((index * 7) % 35)}%` }}
                  />
                )}
              </div>
            ))
          : sidemenuDetails.map((link, index) => (
              <SidebarLink
                key={`${link.label || "item"}-${index}`}
                location={location}
                isSidebarOpened={isSidebarOpened}
                {...link}
              />
            ))}
      </List>
    </Drawer>
  );
  // ##################################################################
  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;
    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(Sidebar);
